export const PROMO_TEXT =
    'Платное продвижение постов для получения больших охватов, трафика и продаж';

export const DIRECT_LINK = 'https://direct.yandex.ru/?utm_source=yandex_rythm';

export const SUPPORT_LINK = 'https://yandex.ru/support2/rythm/ru/buisness/promotion';
